import { generateMathRandom } from './drage'
import { cloneDeep } from 'lodash'
import * as math from 'mathjs'

// isMobile 是否移动端(移动端的大小高度是固定的)
export function generGrid (val, arr, isMobile) {
  const date = {
    x: 0,
    y: 0,
    i: generateMathRandom(arr),
    w: 6,
    h: 18,
    static: false,
    type: val,
    transparentBackground: false, // 背景透明
    projectionTransparent: false, // 投影透明
    viewShow: false, // 隐藏显示 false 显示 true 隐藏
  };
  // 应用列表
  if (val === 'mutual') {
    date.info = {}
    date.name = '应用列表'
    date.pageId = ''
    date.themeColor = '#4e86ff'
  }
  // 容器组件
  if (val === 'container') {
    date.children = [
      // {
      //   name: '栏目名称',
      //   children: [],  // 这里才是设置具体哪个组件的（当前只有有个）
      //   selected: 0,  // 选中打开的
      // }
    ]
    date.reName = '容器组件'
    date.columnFontConfig = textStyle() // 栏目名样式设置
    date.titleBgConfig = { // 表名背景样式设置
      bgType: 'color',
      bgColor: '#FFF',
      bgImg: null,
      bgTemp: 0,
    },
    date.summaryTitleConfig = textStyle() // 表名样式设置
    // 背景设置
    date.bgfillStyle = {
      bgstyle:'color',
      bgTemp: 0, 
      color:'#FFFFFF',
      picture:{
        pictype:'upload',
        layout:'default',
        url:''
      },
    }
    date.selected = 0
    date.navbarPosition = 'top' // top 顶部 left 左侧
    date.navbarStyle = 'one'  // 导航样式
    date.navbarBgImg = ''  // 导航样式四的背景颜色
    date.icon = ''
  }
  //- 明细表，汇总表，指标/饼图公用参数
  if (val === 'detailed' || val === 'summary' || val === 'indicatorsBread') {
    // 名称隐藏显示
    date.nameShow = false
    // 左边应用
    date.allDatas = [];  // 数据源
    date.titleMom = true
    date.isSource = 1;  // 1 表单 2 工坊  11 系统数据表
    date.datasName = '';  // 应用名称
    date.appId = '';  // 应用id
    date.fractional = [];//- 公式字段数据
    // 右边配置
    date.reName = ''; // 表明（外面一起用）
    date.titleBgConfig = { // 表名背景样式设置
      bgType: 'color',
      bgColor: '#FFF',
      bgImg: null,
      bgTemp: 0,
    },
    date.summaryTitleConfig = textStyle() // 表名样式设置
    // 标题更多按钮 false 开启 true 关闭
    date.titleMom = false
    // 背景设置
    date.bgfillStyle = {
      bgstyle:'color',
      picture:{
        pictype:'upload',
        layout:'default',
        url:''
      },
      color:'#FFFFFF',
    }
    date.isCav = 1;  // 是否允许用户导出 1是；2否
    date.pageTotal = 0;// 数据数量
    date.filter = {
      linked: []
    }; // 数据筛选（字典还是数组自己定）
    date.rules = [];//- 客户端时，后端要的当前表管联的筛选组件规则内容
    date.skeletonLoading = false;//- 骨架屏加载显示参数
    date.mobileShowLength = 2;//- 手机端显示长度设置
    date.filedSort = 100;//- 手机端表单顺序
    date.toolbar = false  // 工具条
    date.toolbarConfig = [] // 工具条配置
  }
  // 明细表
  if (val === 'detailed') {
    date.curpage = 1;// 当前页数
    date.article = 25;  // 单页显示数据
    date.reCheck = true;// 是否显示序号
    date.sort = []; // 排序规则（字典还是数组自己定）
    date.selectDatas = [];//- 展示字段参数集
    date.fromdatas = [];//- 表单数据
    date.showWay = 1;//- 显示布局方式功能
    date.tableModel = 'fixed'
    date.listHeight = 22
    date.loadSetting = 'pages'
    date.titleConfig = textStyle()
    date.valueConfig = textStyle()
    date.lineClamp = 1 // 文本行数
    // date.dataSchema = 'details'
  }
  // 汇总表
  if (val === 'summary') {
    date.curpage = 0;// 当前页数
    date.article = 0;  // 单页显示数据
    date.contrast = false //  对比模式
    date.rowWidthConfig = ''  //  行字段

    // 因为前后不统一，这个参数接着用
    date.devArticle = 25;  // 单页显示数据（前端分页使用）
    date.devCurpage = 1;  // 当前页数（前端分页使用）
    date.relevance = [];  //- 关联表单设置数据
    date.isSummary = 1;  // 是否汇总 1 是 2 否
    // 冻结窗格
    date.overflow = {
      x: false,
      y: false
    };
    date.selectGroup = null;//- 小程序客户端点击选中行的组号
    date.selectRow = null;//- 客户端点击选中行序号
    date.selectCloum = null;//- 客户端点击选中列序号
    date.lineClamp = 1
    date.titleConfig = textStyle()
    date.valueConfig = textStyle()
    date.pdfPrint = 'vertical'  // vertical 竖版 across 横版
    date.watermark = [] // date 打印时间  user 打印人
    date.revise = false
    date.reviseConfig = {
      type: 'pick',  // pick 选项 star 评星
      config: [],
      defaultVal: '',
      required: false
    }

  }
  // 文本组件
  if (val === 'text') {
    date.dataconfig = {
      setUpValue: 0
    };
    // 背景设置
    date.bgfillStyle = {
      bgstyle:'color',
      picture:{
        pictype:'upload',
        layout:'default',
        url:''
      },
      color:'#FFFFFF',
    }
    date.functionParms = []
    // 数据源设置
    date.dataSource = {
      isData: false,
      appInfo: {
        app: {},
        fieldList: []
      },
      isChange: false,
      changeMode: 0,
      scrollNum: 0,
    }
    date.bindinf = "";
    date.h = 15;
    date.name = '文本组件';
    date.isShow = true;
    date.filedSort = 100;//- 手机端表单顺序
  }
  // 图片组件
  if (val === 'swiper') {
    date.info = {
      "mobileList":[],
      "pcList":[],
      "rollConfig":{
          "layout":1,
          "roll":"close",
          "rollTime":5,
          "photoShow":"center",
          "sort":999,
          "showPort":[
              "PC",
              "Mobile"
          ],
          "mobilePortSet":1,
          "transparent":false,
          "shadow":false,
          "overPosition":"bottom",
          "overShow":"hidden",
          "isOverSaveArea":"n",
          "isOverContentArea":"n"
      }
    }
    // 数据源设置
    date.dataSource = {
      isData: false,
      appInfo: {
      
      },
    }
    date.name = '图片组件'
  }
  // 筛选器
  if (val === 'Sizer') {
    date.w = 3,
    date.h = 5,
    date.minW = 1.7,  // 最小宽度
    date.minH = 2.5,  // 最小高度
    // 左边应用
    date.sourceDatas = [];  // 可以筛选表的数据源数据
    date.datasName = '';  // 筛选表名称
    date.transparentBackground = true // 背景透明
    date.projectionTransparent = true // 投影透明
    date.FilterField = {
      type: '',//- 筛选器显示的类型
      datas: [],
      condition: [],//- 当前类型筛选器显示的规则内容
      conditionValue: '',//- 当前类型筛选器选择的规则值
    };//- 中间筛选字段数据存放
    date.selectArray = [];//- 存放中间筛选字段数据的fathertype传给后端
    date.FilterValue = [];//- 存放筛选规则设定好的输入值数据（数值模式时，文本模式时,选择人员模式时）
    date.datePickerValue = '';//- 存放筛选规则设定好的输入值数据（时间模式时）
    //- 以下为文本筛选器的特殊值
    date.activeName = 'select';//- 文本筛选器时tab切换值
    date.searchName = '';//- 文本筛选器时文本搜索值
    date.textDataSelShow = [];//- 文本筛选器时文本字段数据
    date.checkAll = false;//- 文本筛选器全选需要参数
    date.isIndeterminate = true;//- 文本筛选器全选需要参数
    date.checkedUserArr = [];//- 筛选器为选择人员模式时，人员二次打开后数据显示的位置
    date.skeletonLoading = false;//- 骨架屏加载显示参数
    date.synchronousOrg = false // 同步组织
    //- 筛选组件文本数据下拉加载参数(现在没用)
    date.textPaging = {
      page: 0,
      size: 500,
      textDataMore: 0,//- 是否展示无数据效果:0：初始状态，1：加载中，2：暂无数据，3：没有更多了
      loadingForbid: false,//- 文本是否可以下拉加载
    }
    date.expandStyle = 'stop'
    // date.organize = []   组织架构选择（该值只有选择了联系人，并选择了组织架构才会有）
  }
  //- 指标/饼图
  if (val === 'indicatorsBread') {
    date.curpage = 0;// 当前页数
    date.article = 0;  // 单页显示数据
    date.chartType = 'indicators';//- 指标图或者饼图类型
    date.ischartBread = false;//- 饼图类型是否禁用
    date.reverseOrder = false;  // 是否数据倒序
    // 因为前后不统一，这个参数接着用
    date.devArticle = 25;  // 单页显示数据（前端分页使用）
    date.devCurpage = 1;  // 当前页数（前端分页使用）
    date.isRowVirtual = true; //- 是否前端自动配置虚拟的row
    date.totalValue = 0;//- 页面总数数据
    date.relevance = [];  //- 关联表单设置数据
    date.selectIndex = null;//- 客户端点击选中序号
    date.mobileLayout = '50%'; // 手机布局
    date.icon = 'http://bigdata.topeti.com/PCRepository/dashBoard/21.png'; // 图标设置
    date.color = '#333'; // 文字颜色

    date.echartsTempId = -1 // 图形样式 -1 为默认

    date.minW = 1  // 最小宽度
    date.w = 3.63
    date.h = 20.1
    // 指标图自定义配置
    date.styleConfig = {
      backTransparent: false,
      projectionTransparent: false,
      backImg: '',
      model: 1,
      icon: {
        type: 1,
        img: ''
      },
      title: {
        w: 200,
        h: 30,
        // x: 61,
        x: 171,
        y: 71,
        show: true,
        fontSize: '20px',
        fontFamily: '微软雅黑',
        fontWeight: 'normal', // 是否加粗
        fontStyle: 'normal', // 是否斜体
        textDecoration: 'none', // 是否下划线
        color: '#333333', // 选择的颜色
        textAlign: 'left' // 位置排版
      },
      // 统计数据
      statistics: {
        fontSize: '50px',
        fontFamily: '微软雅黑',
        fontWeight: 'normal', // 是否加粗
        fontStyle: 'normal', // 是否斜体
        textDecoration: 'none', // 是否下划线
        color: '#4e86ff', // 选择的颜色
        textAlign: 'left' // 位置排版
      },
      // 单位
      unit: {
        w: 240,
        h: 98,
        // x: 55,
        x: 171,
        y: 101,
        show: true,
        unit: '人',
        fontSize: '24px',
        fontFamily: '微软雅黑',
        fontWeight: 'normal', // 是否加粗
        fontStyle: 'normal', // 是否斜体
        textDecoration: 'none', // 是否下划线
        color: '#4e86ff', // 选择的颜色
        textAlign: 'left' // 位置排版
      },
      // 文本
      textArr: [],
      // 图片
      img: {
        w: 104,
        h: 104,
        x: 46,
        y: 70,
        show: true,
        url: 'facet-bg/10.svg'
      }
    }
  }
  // 定时提醒
  if (val === 'message') { 
    // TODO
  }
  // 统计图片
  if (val === 'picture') {
    // TODO
  }

  // 移动端重置大小
  if (isMobile) {
    date.w = 2
    date.h = 27
    if (val === 'detailed') {
      date.tableModel = 'default'
    }
    if (val === 'indicatorsBread') {
      date.w = 1
      date.h = 8
      date.styleConfig.title.w = 130
      date.styleConfig.title.h = 25
      date.styleConfig.title.x = 26
      date.styleConfig.title.y = 22
      date.styleConfig.title.color = '#999999'
      date.styleConfig.title.fontSize = '26px'
      date.styleConfig.statistics.fontSize = '60px'
      date.styleConfig.statistics.color = '#333333'
      date.styleConfig.unit.w = 156
      date.styleConfig.unit.h = 45
      date.styleConfig.unit.y = 57
      date.styleConfig.unit.x = 26
      date.styleConfig.unit.fontSize = '22px'
      date.styleConfig.unit.color = '#999999'
      date.styleConfig.img.w = 56
      date.styleConfig.img.h = 56
      date.styleConfig.img.x = 243
      date.styleConfig.img.y = 72
      date.styleConfig.img.url = 'model1/1.png'
    }
    if (val === 'text') {
      date.h = 50
    }
    if (val === 'Sizer') {
      date.w = 0
      date.h = 0
      date.x = 0
      date.y = 0
      date.unfold = 'no'
    } else {
      date.fullWidth = false  // 是否宽度拉满
      date.fullWidthTop = false  // 是否高度拉满
    }
    if (val === 'summary') {
      date.dataMerge = 'row'  // 数据合并方式
    }
  }
  return date;
}

/*
* 返回初始化文字样式设置
* */
export function textStyle () {
  return {
    fontSize: '14px',
    fontFamily: '微软雅黑',
    fontWeight: 'normal', // 是否加粗
    fontStyle: 'normal', // 是否斜体
    textDecoration: 'none', // 是否下划线
    color: '#333', // 选择的颜色
    textAlign: 'left' // 位置排版
  }
}
// export const textStyle = {
//   fontSize: '14px',
//   fontFamily: '微软雅黑',
//   fontWeight: 'normal', // 是否加粗
//   fontStyle: 'normal', // 是否斜体
//   textDecoration: 'none', // 是否下划线
//   color: '#333', // 选择的颜色
//   textAlign: 'center' // 位置排版
// }

/**
 * 返回参数值
 * */
export function retSummary (val) {
  const dictionary = {
    count: '计数',
    sum: '求和',
    avg: '求平均',
    max: '求最大值',
    min: '求最小值'
  };
  if (!dictionary[val]) return '';
  return dictionary[val];
}

/**
 *  仪表盘生成不重复的随机数
 * */
export function generate_IsMathRandom (val, key = 'i') {
  let date = parseInt((Math.random() * 9 + 1) * 100000);
  if (val.findIndex(val => { return val[key] === date }) !== -1) {
    return generate_IsMathRandom(val);
  } else {
    return date;
  }
}

/**
 *  仪表盘筛选组件，获取本身设置规则数据
 * */
export function screeningRules (datas) {
  //- 记录要添加的筛选规则内容·
  let fitherVlaue = '';//- 存放筛选字段数据值
  let condition = datas.FilterField.conditionValue;//- 存放筛选规则数据值
  if (datas.FilterField.type !== 'date') {
    fitherVlaue = datas.FilterValue;
  } else {
    //- 时间属性的取值处(数组)
    fitherVlaue = datas.datePickerValue;
    switch (condition) {
      case 'thatDay': //- 时间属性的取值处(数组)
        fitherVlaue = [0, 0];
        break
      case 'yesterday': // 昨天
        fitherVlaue = [-1, 0];
        break
      case 'thisWeek':  // 本周
        fitherVlaue = [0, 7];
        break
      case 'lastWeek':  // 上周
        fitherVlaue = [-7, 0];
        break
      case 'thisMonth': // 本月
        fitherVlaue = [0, 30];
        break
      case 'lastMonth': // 上月
        fitherVlaue = [-30, 0];
        break
    }
/*
    //- 时间属性的取值处(数组)
    if (condition === 'thatDay') {
      fitherVlaue = [0, 0];
    }
    // 昨天
    if (condition === 'yesterday') {
      fitherVlaue = [-1, 0];
    }
    // 本周
    if (condition === 'thisWeek') {
      fitherVlaue = [0, 7];
    }
    // 上周
    if (condition === 'lastWeek') {
      fitherVlaue = [-7, 0];
    }
    // 本月
    if (condition === 'thisMonth') {
      fitherVlaue = [0, 30];
    }
    // 上月
    if (condition === 'lastMonth') {
      fitherVlaue = [-30, 0];
    }
*/
    condition = 'between'
  }
  //- 人物特殊规则数据值
  if (datas.FilterField.type === 'relation-user') {
    condition = "in";
  }
  //- 文本物特殊规则数据值
  if (['status', 'text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'new-rel-radio', 'relation-check', 'label'].indexOf(datas.FilterField.type) !== -1) {
    if (datas.activeName === 'select' || datas.activeName === 'customize' || datas.activeName === 'dictionary') {
      condition = "in";
    } else {
      condition = "like";
    }

    if (datas.FilterField.type === 'status') {
      let status_array = [];
      fitherVlaue.forEach((item) => {
        if (item === '进行中') {
          status_array.push(0);
        } else if (item === '已通过') {
          status_array.push(1);
        } else if (item === '未通过') {
          status_array.push(2);
        } else if (item === '已撤回') {
          status_array.push(3);
        }
      })
      fitherVlaue = status_array;
    }

  }
  if (['organization', 'roule'].indexOf(datas.FilterField.type) !== -1) {
    condition = "in";
  }

  let pushdatas = {
    filterId: datas.i,//- 筛选组件id
    title: datas.datasName,//- 筛选组件名称
    value: fitherVlaue,//- 提交值
    relation: condition//- 筛选条件
  }

  return pushdatas
}

/**
 * 取列值
 * */
export function retRowObj (arr, obj, ind, str) {
  let arrst = [];
  // 生成数组
  for (let i = 0; i < obj[arr[ind].name].length; i++) {
    let ar = JSON.parse(JSON.stringify(str));
    // let strName = filterSymbol(arr[ind].name);
    // ar[strName] = obj[arr[ind].name][i];
    ar[arr[ind].name] = obj[arr[ind].name][i];
    let arrInd = JSON.parse(JSON.stringify(ind)) + 1;
    if (arr.length > arrInd) {
      let date = retRowObj(arr, obj, arrInd, ar);
      arrst = arrst.concat(date);
    } else {
      arrst.push(ar);
    }
  }
  return arrst;
}

/**
 * 时间处理
 * */
export function getYearWeek (a, b, c) {
  var date1 = new Date(a, parseInt(b) - 1, c), date2 = new Date(a, 0, 1),
    d = Math.round((date1.valueOf() - date2.valueOf()) / 86400000);
  return Math.ceil((d + ((date2.getDay() + 1) - 1)) / 7);
}
export function timeSub (time, format) {
  if (!format || !time) return time;
  let date = new Date(time);
  let Y = date.getFullYear();
  let M = date.getMonth() + 1;
  let D = date.getDate();
  let h = date.getHours();
  let m = date.getMinutes();
  let s = date.getSeconds();
  switch (format) {
    case 'yyyy-MM-dd HH:mm:ss':
      return time;
    case 'yyyy-MM-dd':
      return Y + '-' + (M < 10 ? '0' : '') + M + '-' + (D < 10 ? '0' : '') + D;
    case 'yyyy-MM-dd HH':
      return Y + '-' + (M < 10 ? '0' : '') + M + '-' + (D < 10 ? '0' : '') + D + ' ' + (h < 10 ? '0' : '') + h;
    case 'yyyy-MM-dd HH:mm':
      return Y + '-' + (M < 10 ? '0' : '') + M + '-' + (D < 10 ? '0' : '') + D + ' ' + (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
    case 'yyyy':
      return Y + '年';
    case 'yyyy-MM':
      return Y + '年' + M + '月';
    case 'yyyy-WW':
      return Y + '年' + getYearWeek(Y, M, D) + '周';
    case 'HH:mm:ss':
      return h + '时' + m + '分' + s + '秒';
    case 'yyyy-MM-dd WW':
      return Y + '年' + M + '月' + D + '日 ' + getYearWeek(Y, M, D) + '周'
    case 'yyyy-MM-dd EEE':
      return Y + '-' + (M < 10 ? '0' : '') + M + '-' + (D < 10 ? '0' : '') + D + ' 星期' + getWeek(time)
    case 'EEE':
      return '星期' + getWeek(time)
  }
  // 如果是默认的，直接放后台给什么就是什么
  // if (format === "yyyy-MM-dd HH:mm:ss") return time;
  // if (format === "yyyy-MM-dd") return Y + '-' + (M < 10 ? '0' : '') + M + '-' + (D < 10 ? '0' : '') + D;
  // if (format === "yyyy-MM-dd HH") return Y + '-' + (M < 10 ? '0' : '') + M + '-' + (D < 10 ? '0' : '') + D + ' ' + (h < 10 ? '0' : '') + h;
  // if (format === "yyyy-MM-dd HH:mm") return Y + '-' + (M < 10 ? '0' : '') + M + '-' + (D < 10 ? '0' : '') + D + ' ' + (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
  // // if (format === "yyyy-MM-dd HH:mm:ss") return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
  // if (format === "yyyy") return Y + '年';
  // if (format === "yyyy-MM") return Y + '年' + M + '月';
  // if (format === "yyyy-WW") return Y + '年' + getYearWeek(Y, M, D) + '周';
  // if (format === "HH:mm:ss") return h + '时' + m + '分' + s + '秒';
}

/**
 * 当前日期
 * */
export function dateSub () {
  let date = new Date();
  let Y = date.getFullYear();
  let M = date.getMonth() + 1;
  let D = date.getDate();
  let W = date.getDay();
  let arr_week = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
  return Y + '年' + M + '月' + D + '日 ' + arr_week[W];
}


// 显示星期几
export function getWeek(time) {
  let date = null;
  try {
    date = new Date(time)
  } catch (e) {
    return time
  }
  const week = ['日', '一', '二', '三', '四', '五', '六'];
  return week[date.getDay()];
}

/**
 * 时间
 * */
export function numberSub (val, format) {
  if (!val || !format) return val;
  if (typeof val !== 'number') val = Number(val);
  return val.toFixed(format);
}

// 文本加密
export function textSub (val, limitNum) {
  //- val数据，limitNum加密长度限定判断
  // console.log("val===>", val)
  if (val) {
    if (typeof (val) === "number") {
      val = val.toString()
    }
    if (val.length > limitNum) {
      //- 内容字符超limitNum长度时候，则加密
      let showData = val.substring(val.length - limitNum);
      showData = "******" + showData;
      return showData

    } else {
      //- 内容字符不满六位，则没有加密效果
      return val
    }


  }

}

/***
 * 过滤掉 .
 */
export function filterSymbol (str) {
  if (!str && str !== 0) return str
  return str.split('.').join('');
}

/**
 * 第二版汇总表解析
 * date 后台查询结果集  row 行  column 列 summary 筛选  columnArrs 列结果集 dates 配置
 * **/
export function getGenerateTableTopTwo (date, row, column, summary, isSummary, pool = [], contrast = [], isPool = false) {
  console.log('第二版解析', date, row, column, summary);
  // console.log('解析的data', JSON.stringify(date))
  // console.log('解析的row', JSON.stringify(row))
  // console.log('解析的column', JSON.stringify(column))
  // console.log('解析的summary', JSON.stringify(summary))
  // console.log('解析的pool', JSON.stringify(pool))
  // let summaryLen = 0;
  let dateArrLen = 0;
  let rows = column.map(val => { return val.name }); // 列
  let cols = row.map(val => { return val.name }); // 行
  let sums = summary.map(val => { return val.name }); // 汇总
  console.log('解析值', rows, cols, sums)

  let topObj = {};
  let left = {};
  date.forEach(val => {

    // console.log('遍历值', val)
    // 走行
    topObj = retObj(rows, val, sums, topObj);
    // 走列
    left = retLeft(cols, val, left);
  });

  // 计算列表
  let topArr = upFor(rows, cols, [], JSON.parse(JSON.stringify(row)));  // 行列汇总字段表头
  let leftArr = [];
  let dateArr = [];
  // 汇总
  let XsummaryArr = {};

  // 做左边列
  retLeftArr(left, leftArr, 0);

  let topArrse = retTopArr(topObj, topArr, cols, leftArr, sums, isSummary);

  // 值拼接
  (cols || [0]).forEach((val, index) => {
    let vals = filterSymbol(val);
    XsummaryArr[vals] = '汇总';
    if (leftArr[index] && leftArr[index].length > 0) {
      leftArr[index].forEach((item, itemIndex) => {
        dateArr[itemIndex][vals] = item;
      })
    }
  });

  // 汇总判断
  if (isSummary === 1) {
    if (rows.length !== 0) {
      // 尾部汇总表头添加
      topArrse.push({
        label: '汇总',
        children: sums.map(val => {
          return {
            label: val,
            ind: filterSymbol(val)
          }
        })
      });
    }
    // 把 横向汇总合并过去(cols 为空的情况下，不需要)
    if (cols.length !== 0) {
      // 遍历判断是否有对应数据，没有的话才计算更新
      if (sums && sums.length > 0 && !XsummaryArr[sums[0]] && XsummaryArr[sums[0]] !== 0) {
        const sumObs = {}
        for (const i of dateArr) {
          for (const a of sums) {
            const aVal = filterSymbol(a)
            // 两位精度计算
            const val1 = (i[aVal] || 0) * 100
            const val2 = (sumObs[aVal] || 0) * 100
            sumObs[aVal] = (val1 + val2) / 100
            // sumObs[aVal] = (i[aVal] || 0) + (sumObs[aVal] || 0)
          }
        }
        XsummaryArr = { ...XsummaryArr, ...sumObs }
      }
      dateArr.push(XsummaryArr);
    }

  }

  // console.log('第二版解析至', rows, cols, sums, topObj, left, 'leftArr:', leftArr, 'topArrse：', topArrse, topArr, ars, 'dateArr:', dateArr, 'XsummaryArr:', XsummaryArr);

  function retObj (row, list, sum, obj) {
    let objs = JSON.parse(JSON.stringify(obj));
    if (row.length > 0) {
      let val = list[row[0]] + '-';
      let rows = JSON.parse(JSON.stringify(row));
      let lists = JSON.parse(JSON.stringify(list));
      delete lists[row[0]];
      rows.splice(0, 1);
      objs[val] = retObj(rows, lists, sum, objs[val] || {});
      return objs;
    } else {
      for (let i = 0; i < sum.length; i++) {
        // summaryLen += 1;
        if (obj[sum[i]]) {
          objs[sum[i]].push(list)
        } else {
          objs[sum[i]] = [list];
        }
      }
      return objs;
    }
  }
  function retTopArr (val, arr, col, leftArr, sum, isSummary) {
    for (let i in val) {
      let obj = null;
      // console.log('查看数据--判断', JSON.parse(JSON.stringify(arr)), i)
      // 如果后续值为数组的话，则计算当前是第几列
      if (!Array.isArray(val[i])) {
        obj = {
          label: i.slice(0, i.length - 1),
        };
        obj.children = retTopArr(val[i], [], col, leftArr, sum, isSummary);
      } else {
        obj = {
          label: i,
          ind: 't_' + dateArrLen
        };
        let sum = 0;
        for (let a = 0; a < val[i].length; a++) {
          let index = retInfo(val[i][a], col, leftArr);
          if (index !== -1) {
            // 汇总两位数精度计算
            const sumValue = val[i][a][i] * 100
            sum += sumValue;
            // sum += val[i][a][i];
            if (!dateArr[index]) dateArr[index] = {};
            dateArr[index]['t_' + dateArrLen] = val[i][a][i];
            if (isSummary === 1) {
              // 计算汇总
              let is = filterSymbol(i);
              if (!dateArr[index][is]) {
                dateArr[index][is] = val[i][a][i];
              } else {
                // 汇总两位小数计算
                const sumVal = val[i][a][i] * 100
                const sum1Val = dateArr[index][is] * 100
                dateArr[index][is] = (sumVal + sum1Val) / 100;
                // dateArr[index][is] += val[i][a][i];
              }
            }
          }
        }
        XsummaryArr['t_' + dateArrLen] = sum / 100;
        // XsummaryArr['t_' + dateArrLen] = sum;
        dateArrLen += 1;
      }
      if (obj.ind || obj.ind === 0) {
        // 根据label查询汇总对应筛选
        const sInd = (summary || []).findIndex(it => it.name === obj.label)
        if (sInd !== -1) {
          obj.order = summary[sInd].order || false
          obj.screen = summary[sInd].screen || false
        }
      }
      arr.push(obj);
    }

    return arr;
  }

  // 判断列汇总（使用列字段计算）
  if (column && column.length > 0) {
    for (let i = 0; i < column.length; i++) {
      if (column[i].pool && column[i].poolConfig && column[i].poolConfig.length > 0) {
        // 与汇总字段进行遍历同步汇总最新的name
        const poolSum = column[i].poolConfig.map(it => {
          const ind = summary.findIndex(its => its.title === it.title && its.type === it.type)
          if (ind !== -1) {
            it.name === summary[ind].name
          }
          return it
        })
        try {
          // console.log('计算1')
          topArrse = poolColumn(topArrse, poolSum, i, 0, dateArr, '', summary)
          // console.log('列终结果', JSON.parse(JSON.stringify(topArrse)), JSON.parse(JSON.stringify(dateArr)))
        } catch (err) { console.log('计算出错', err) }
      }
    }
  }

  if (row && row.length > 0) {
    // console.log('列计算', row, cols)
    const endObj = {}
    // let len = 0
    for (const a of summary) {
      // console.log('最终个数', poolEnd(topArrse, a.name, []))
      const lenS = poolEnd(topArrse, a.name, [])
      // len = lenS.length
      endObj[a.name] = lenS
    }

    for (let i = 0; i < row.length; i++) {
      if (row[i].pool && row[i].poolConfig && row[i].poolConfig.length > 0) {
        const poolSum = row[i].poolConfig.map(it => {
          const ind = summary.findIndex(its => its.title === it.title && its.type === it.type)
          if (ind !== -1) {
            it.name === summary[ind].name
          }
          return it
        })
        try {
          dateArr = rowPool1(cols.slice(0, i + 1), poolSum, dateArr, endObj, cols[i + 1])
          // console.log('行输出', dateArr)
        } catch (err) { console.log('计算出错1', err) }
      }
    }
  }
  if (isPool && pool && pool.length > 0 && column && column.length > 0) {
    try {
      topArrse = contrastSort(topArrse, dateArr, { target: column.length, current: 0, contrastVal: contrast, pool: pool } )
    } catch (err) { console.log('err2', err) }
  }
  let partitionList = null
  if (row && row[0] && row[0].partition) {
    if (!column || column.length === 0) {
      topArrse = topArrse.slice(1, topArrse.length)
    } else {
      const topArrseOne = partitionArr(JSON.parse(JSON.stringify([topArrse[0]])), row[0].name)
      topArrse[0] = topArrseOne[0]
    }
    const rowKey = row[0].name
    partitionList = Array.from(new Set(dateArr.map(it => it[rowKey])))
    if (isSummary && dateArr[dateArr.length - 1][row[0].name] === '汇总') {
      partitionList.splice(partitionList.length - 1, 1)
    }
  }
  // 回抛
  const hp = { top: topArrse, info: dateArr }
  if (partitionList) hp.partitionList = partitionList
  return hp
}

function partitionArr (arr = [], key = '') {
  const e = []
  for (let i = 0; i < arr.length; i++) {
      const item = arr[i]
      if (item.label !== key) {
          if (item.children && item.children.length > 0) item.children = partitionArr(item.children, key)
          e.push(item)
      }
  }
  return e
}

function contrastSort (topArrse, dateArr, { target, current, contrastVal = [], pool = [] }) {
  console.log('进行计算', topArrse)
  // console.log('进行计算topArrse', JSON.stringify(topArrse))
  // console.log('进行计算dateArr', JSON.stringify(dateArr))
  // console.log('进行计算cc', JSON.stringify({ target:target , current: current, contrastVal: [], pool: pool }))

  if (!topArrse || topArrse.length === 0) return topArrse
  const key = current + 1
  const basis = []
  const basisObj = {}
  const contrast = []
  const leftObj = []
  let isContrast = false
  for (let i = 0; i < topArrse.length; i++) {
    if (current === 0 && i === 0) {
      leftObj.push(topArrse[i])
      continue
    }
    if (key === target) {
      // console.log('数据匹配上了', topArrse[i])
      isContrast = true
      if (contrastVal.length > 0 && contrastVal.includes(topArrse[i].label) || (!contrastVal || contrastVal.length === 0) && i === 0) {
        basis.push(topArrse[i])
        // console.log('做原始值结构', topArrse[i])

        for (const s of (topArrse[i].children || [])) {
          if (!basisObj[s.label]) basisObj[s.label] = []
          basisObj[s.label].push(s.ind)
        }
      } else {
        contrast.push(topArrse[i])
      }
    } else if (topArrse[i].children && topArrse[i].children.length > 0) {
      try {
        topArrse[i].children = contrastSort(topArrse[i].children, dateArr, { target: target, current: key, contrastVal, pool: pool })
      } catch (err) { console.log('err1', err) }
    }
  }
  if (isContrast) {
    // 有基础值的情况下做对比值计算
    // console.log('基础值', basis, basisObj)
    // console.log('对比值', contrast)
    contrast.forEach((c) => {
      // console.log('第一季对比', c, cInd)
      // 遍历对壁纸
      const name = 's'
      const cArr = []
      for (let ci = 0; ci < (c.children || []).length; ci++) {
        const cItem = c.children[ci]
        cArr.push(cItem)
        // 找到当前对应下去的汇总字段
        const pi = pool.findIndex(it => it.name === cItem.label)
        // console.log('找下标', pi, pool, cItem)
        if (pi !== -1) {
          const a = pool[pi]
          let name1 = name + '_' + cItem.ind
          const ob = { label: a.label, ind: name1 }
          if (a.colorConfig && a.colorConfig.isColor && a.colorConfig.options && a.colorConfig.options.length > 0) ob.colorConfig = a.colorConfig
          cArr.push(ob)
          dateArr.forEach(d => {
            if (a.condition !== 'formula') {
              
              const one = (basisObj[a.name] || []).map(it => d[it])
              const two = [d[cItem.ind]]
              // 正常运算 基础值的对应配置 + 对比值 组合成一个数组
              const vv = [...one, ...two].filter(it => it)
              // console.log('正常运算', vv, one, two, basisObj[a.name])
              try {
                d[name1] = countPool(vv, a.condition)
              } catch (err) { console.log('err11', err) }
            } else if (a.formula && a.formula.condition) {
              const strFilter = (a.formula.condition).match(/([A-Z]+)\((.*)\)/);
              if (strFilter && strFilter.length >= 3) {
                const mathFun = strFilter[1];
                const nameVal = strFilter[2] || '';

                let s = nameVal.replace(/<[^>]+>/g, function(match) {
                  const v = match.replace(/<|>/g, '')
                  const vName = v.substring(0, v.length - 5)
                  const vVal = v.substring(v.length - 5)
                  const vObj = {
                    '(基础值)': basis,
                    '(对比值)': [c]
                    // '(对比值)': contrast
                  }
                  let val = vObj[vVal].map(it => {
                    return (it.children || []).map(its => {
                      return its.label === vName ? d[its.ind] : ''
                    }).filter(ite => ite || ite === 0)
                  })
                  try {
                    if (val && val[0]) val = val.reduce((a, b) => a.concat(b))
                  } catch (err) {
                    // console.log('reduce报错', val)
                  }
                  // console.log('公式值', v, val)
                  return val && val.length > 0 ? val : [0]
                })

                // console.log('公式字段结果', name1, nameVal, s, d)
                s = s.split(',').filter(it => it || it === 0).join(',')
                try {
                  d[name1] = s ? mathFunRun(s, mathFun) : ''
                } catch (err) {
                  console.log('计算错误3', err)
                }
              }
            }
          })
        }
      }
      
      c.children = cArr
    })
    return [ ...leftObj, ...basis, ...contrast ]
  } else {
    return topArrse
  }
}



function rowPool1 (key = [], config, dateArr = [], endObj) {
  // console.log('下来走', key, config, dateArr, endObj)
  if (!key || key.length === 0 || dateArr.length === 0) return dateArr
  const rtArr = []
  let hKey = []
  for (let i = 0; i < dateArr.length; i++) {
    const one = key.map(it => dateArr[i][it]).join('')
    const two = dateArr[i + 1] ? key.map(it => dateArr[i + 1][it]).join('') : ''
    rtArr.push(dateArr[i])
    // console.log('判断数据是否一样', two, one)
    if (two === one) {
      // 前后两条一样的，挂起当条的数据做合并
      hKey.push(dateArr[i])
    } else {
      if (hKey.length > 0) {
        // 这边走配置汇总的内容决定他是什么汇总方式
        hKey.push(dateArr[i])
        const ob = {
          isPoolRow: true
        }
        for (const ss of key) {
          ob[ss] = dateArr[i][ss]
        }
        for (const ss of config) {
          // 获取到固定字段的下列
          if (endObj[ss.name]) {
            // console.log('固定字段的下列', ss, ob, nKey, endObj[ss.name])
            if (endObj[ss.name] && endObj[ss.name].length > 0) {
              for (let sa = 0; sa < endObj[ss.name].length; sa++) {
                const aa = endObj[ss.name][sa]
                // console.log('合计数组4', aa)
                if (ss.condition !== 'formula') {
                  const aaArr = hKey.map(it => it[aa] || it[aa] === 0 ? it[aa] : '')
                  ob[aa] = countPool(aaArr, ss.condition)  
                } else {
                  ob[aa] = rowPoolFormula(hKey, ss.formula.condition, endObj, sa)
                }
              }
              // for (const aa of endObj[ss.name]) {
              //   const aaArr = hKey.map(it => it[aa] || it[aa] === 0 ? it[aa] : '')
              //   console.log('合计数组3', aaArr)
              //   ob[aa] = countPool(aaArr, ss.condition, ss.formula, { yKey: hKey, endObj: endObj })
              // }
            }
          }
          ob[key[key.length - 1]] = ss.name
        }
        rtArr.push(ob)
        hKey = []
      }
    }
  }
  return rtArr
}

// key 目标层级 dKey 当前层级
// 遍历的时候层级加一处理，因为是树形结构，所以通过递归走层级查询和数据替换
function poolColumn (topArr, config = [], key, dKey, dateArr = [], keyName, summary) {
  // console.log('poolColumn--', topArr, key, dKey, key === 0 && dKey === 0)
  if (key === 0 && dKey === 0) {
    const endObj = {}
    for (const i of summary) {
      endObj[i.name] = poolEnd(topArr, i.name, [])
    }
    // key 为 0 则是第一个 这时候他没有下级
    for (let a = 0; a < config.length; a++) {
      const z = poolEnd(topArr, config[a].name, [])
      // console.log('第一季的内容', z, a)
      const ob = { label: config[a].label, ind: 'c_' + '初始' + '_初始' + a }
      // const ob = { label: config[a].name, ind: 'c_' + key + '_' + a }
      // console.log('当前添加的头列', config[a])
      if (config[a].colorConfig && config[a].colorConfig.isColor && config[a].colorConfig.options && config[a].colorConfig.options.length > 0) ob.colorConfig = config[a].colorConfig
      // 统计合计数据
      for (let d = 0; d < dateArr.length; d++) {
        if (config[a].condition !== 'formula') {
          const h = z.map(it => dateArr[d][it] || dateArr[d][it] === 0 ? dateArr[d][it] : '')
          // console.log('合计数据数组1', h)
          // 这里用数组 h 根据条件计算具体值
          dateArr[d][ob.ind] = countPool(h, config[a].condition)
        } else {
          try {
            dateArr[d][ob.ind] = countPoolFormula(config[a].formula, dateArr[d], endObj)
          } catch (err) {
            console.log('err4', err)
          }
        }
      }
      topArr.push(ob)
    }
    return topArr
  }
  const k = dKey + 1
  for (let i = 0; i < topArr.length; i++) {
    if (topArr[i].config) continue
    if ((!keyName || keyName !== topArr[i].label) && k === key && topArr[i].children) {
      // console.log('找到对应', topArr[i])
      const endObj = {}
      for (const s of summary) {
        endObj[s.name] = poolEnd(topArr[i].children, s.name, [])
      }
      for (let a = 0; a < config.length; a++) {
        // console.log(config[a])
        // 查询到树形的对应最后一级
        const z = poolEnd(topArr[i].children, config[a].name, [])
        // console.log('扁平化后的内容', z, a)
        const ob = { label: config[a].label, ind: 'c_' + topArr[i].label + '_' + a }
        // const ob = { label: config[a].name, ind: 'c_' + key + '_' + a }
        if (config[a].colorConfig && config[a].colorConfig.isColor && config[a].colorConfig.options && config[a].colorConfig.options.length > 0) ob.colorConfig = config[a].colorConfig
        // 统计合计数据
        for (let d = 0; d < dateArr.length; d++) {
          if (config[a].condition !== 'formula') {
            const h = z.map(it => dateArr[d][it] || dateArr[d][it] === 0 ? dateArr[d][it] : '')
            // console.log('合计数据数组2', h, z, topArr[i].children, k ,key)
            // 这里用数组 h 根据条件计算具体值
            dateArr[d][ob.ind] = countPool(h, config[a].condition)
          } else {
            try {
              dateArr[d][ob.ind] = countPoolFormula(config[a].formula, dateArr[d], endObj)
            } catch (err) { console.log('err5', err) }
            // console.log('统计结果', dateArr[d][ob.ind])
          }
        }
        topArr[i].children.push(ob)
      }
    } else if ((!keyName || keyName !== topArr[i].label) && topArr[i].children && topArr[i].children.length > 0) {
      topArr[i].children = poolColumn(topArr[i].children, config, key , k, dateArr, keyName, summary)
    }
  }
  return topArr
}
// 列汇总公式字段
function countPoolFormula ({ condition }, dateArr, endObj) {
  // console.log('列汇总公式字段计算', condition, dateArr, endObj)
  // 解析公式字段（condition），获取公式字段里面的公式和具体字段，使用字段获取到 endObj里面的具体字段，查询datearr 里面的具体值，在走公式获得最终值
  const strFilter = condition.match(/([A-Z]+)\((.*)\)/);
  if (strFilter && strFilter.length >= 3) {
    const mathFun = strFilter[1];
    const nameVal = strFilter[2] || '';
    // const val = funCount(nameVal, yKey, endObj)
    const sl = nameVal.split(',<').length
    const isConcat = mathFun === 'CONCAT' && containsOperator(nameVal)
    const s = nameVal.replace(/<[^>]+>/g, function(match) { 
      const v = match.replace(/<|>/g, '')
      if (endObj[v]) {
        const t = endObj[v]
        const j = t.map(it => dateArr[it] || dateArr[it] === 0 ? dateArr[it] : '').filter(ite => ite || ite === 0)
        if (sl <= 1 && !isConcat) {
          return  j && j.length > 0 ? j : [0]
        } else {
          return j && j.length > 0 ? math.sum(j) : [0]
        }
      }
    })
    // console.log('统计数', s, nameVal, sl)
    try {
      return mathFunRun(s, mathFun)
    } catch (err) { console.log('err6', err) }
  }
  return ''
}
// 暂用的计算展位
function countPool (arr, key) {
  try {
    // console.log('这里是数学库计算', key, arr, math[key](arr))
    if (key === 'count') {
      return arr.filter(it => it || it === 0).length
    } else {
      const s = {
        avg: 'mean'
      }
      return math[s[key] || key](arr)  
    }
  } catch (err) { console.log('计算库错误', err, key, arr) }
  return ''
}
// 函数计算-所有函数列表
function mathFunRun(val, mathFun){
  // 多个文本合并，使用数组进行拼接
  let countArr = val.split(",")
  let concatenatedString = ''
  let resultVal = ''
  let undefinedLen = 0
  for(let i = 0; i < countArr.length; i++){
    if(countArr[i] != 'undefined'){
      concatenatedString += countArr[i]
    }
    else undefinedLen++
  }
  if(undefinedLen == countArr.length){
    return resultVal = undefined
  }
  const index = val.indexOf(',');
  switch (mathFun) {
    case "IF":
      // IF三元运算
      resultVal = evaluateCondition(countArr)
      break;
    case "SUM":
      // 求和
      resultVal = math.evaluate('sum('+val+')')
      break;
    case "MAX":
      // 最大数
      resultVal = math.evaluate('max('+val+')')
      break;
    case "MIN":
      // 最小数
      resultVal = math.evaluate('min('+val+')')
      break;
    case "MOD":
      // 两数相除的余数
      resultVal = math.evaluate('mod('+val+')')
      break;
    case "AVG":
      // 平均值
      resultVal = math.evaluate('mean('+val+')')
      resultVal = resultVal.toFixed(2)
      break;
    case "ABS":
      // 绝对值
      resultVal = math.evaluate('abs('+val+')')
      break;
    case "CONCAT":
      if(containsOperator(val)){
        // 加减乘除计算
        resultVal = math.evaluate(val)
      } else{
        // 多个文本合并
        resultVal = math.concat(concatenatedString)
      }
      break;
    case "ROUND":
      // 小数点格式化
      if (index === -1) {
        // 字符串中不包含逗号
        resultVal = math.round(val)
      } else{
        const before = val.substring(0, index);
        const after = val.substring(index + 1);
        resultVal = math.round(before,after)
      }
      break;
    default:
      break;
  }
  return resultVal;
}
// 正则表达式匹配 +、-、* 或 /
function containsOperator(str) {
  return /[+\-*/]/.test(str);
}
// 函数运算if三元运算
function evaluateCondition (arr) {
  const condition = arr[0];
  const trueValue = arr[1].replace(/"/g, '');
  const falseValue = arr[2].replace(/"/g, '');
  let result;
  if (condition.includes('>') && !condition.includes('>=')) { //大于
    const operands = condition.split('>');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand > rightOperand ? trueValue : falseValue;
  } else if (condition.includes('>=')) { //大于等于
    const operands = condition.split('>=');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand >= rightOperand ? trueValue : falseValue;
  } else if (condition.includes('<') && !condition.includes('<=')) { //小于
    const operands = condition.split('<');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand < rightOperand ? trueValue : falseValue;
  } else if (condition.includes('<=')) { //小于等于
    const operands = condition.split('<=');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand <= rightOperand ? trueValue : falseValue;
  } else if (condition.includes('!=')) { //不等于
    const operands = condition.split('!=');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand != rightOperand ? trueValue : falseValue;
  } else if (condition.includes('=')) { //等于
    const operands = condition.split('=');
    const leftOperand = parseFloat(operands[0]);
    const rightOperand = parseFloat(operands[1]);
    if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
    else result = leftOperand == rightOperand ? trueValue : falseValue;
  } else {
    // 未知条件
    console.log("所有IF条件都不匹配，请重试");
  }
  return result;
}
function poolEnd (config = [], dKey, arr) {
  for (const i of config) {
    if (i.children && i.children.length > 0) {
      arr = poolEnd(i.children, dKey, arr)
    } else if (i.ind && i.label === dKey) {
      arr.push(i.ind)
    }
  }
  return arr
}

export function toolbarSearch (config, list) {
  if (!config || config.length === 0 || !list || list.length === 0) return { list: list, contrast: [], isBasis: false }
  let basis = []
  let isContrast = false
  let allValue = []
  const basisArr = []
  const contrastArr = []
  for (let ia = 0; ia < config.length; ia++) {
    const i = config[ia]
    if (i.attribute && i.attribute === 'base') {
      if (i.value && i.value.length > 0) {
        if (Array.isArray(i.value)) {
          basis = basis.concat(i.value)
          allValue = allValue.concat(i.value)
        } else {
          basis.push(i.value)
          allValue.push(i.value)
        }
      }
      basisArr.push(i)
      const ind = list.findIndex(it => it.filterId === i.i)
      if (ind !== -1) {
        list[ind].value = []
      }
    } else if (i.attribute && i.attribute === 'contrast') {
      if (i.value && i.value.length > 0) {
        if (Array.isArray(i.value)) {
          allValue = allValue.concat(i.value)
        } else {
          allValue.push(i.value)
        }
        isContrast = true
      }
      contrastArr.push(i)
      const ind = list.findIndex(it => it.filterId === i.i)
      if (ind !== -1) {
        list[ind].value = []
      }
    }
  }
  // 判断赋值
  if (contrastArr.length > 0) {
    const ind = list.findIndex(it => it.filterId === contrastArr[0].i)
    if (ind !== -1) {
      list[ind].value = allValue
    } else {
      const ob = {
        filterId: contrastArr[0].i,
        title: contrastArr[0].newDataName || contrastArr[0].checkName,
        value: allValue,
        relation: contrastArr[0].screenType === 'date' && Array.isArray(contrastArr[0].FilterValue) && contrastArr[0].FilterValue.length > 1 ? 'between' : contrastArr[0].activeName ? (contrastArr[0].activeName !== 'text' ? 'in' : 'like') : 'like'
      }
      list.push(ob)
    }
  } else if (basisArr.length > 0) {
    const ind = list.findIndex(it => it.filterId === basisArr[0].i)
    if (ind !== -1) {
      list[ind].value = allValue
    } else {
      const ob = {
        filterId: basisArr[0].i,
        title: basisArr[0].newDataName || basisArr[0].checkName,
        value: allValue,
        relation: basisArr[0].screenType === 'date' && Array.isArray(basisArr[0].FilterValue) && basisArr[0].FilterValue.length > 1 ? 'between' : basisArr[0].activeName ? (basisArr[0].activeName !== 'text' ? 'in' : 'like') : 'like'
      }
      list.push(ob)
    }
  }
  // 如果只有
  return { list: list, contrast: basis, isBasis: isContrast }
}

function retLeft (col, list, obj) {
  if (col.length > 0) {
    let val = list[col[0]] + '-';
    let cols = JSON.parse(JSON.stringify(col));
    cols.splice(0, 1);
    if (cols.length > 0) {
      obj[val] = retLeft(cols, list, obj[val] || {});
      return obj;
    } else {
      obj[val] = '';
      return obj;
    }
  }
}
function retLeftArr (val, arr, len) {
  for (let i in val) {
    if (!arr[len]) arr[len] = [];
    arr[len].push(i.slice(0, i.length - 1));
    // arr[len].push(i);
    if (val[i] && typeof val[i] === 'object') {
      arr = retLeftArr(val[i], arr, (len + 1));
      for (let a = 0; a < (arr.length - 1); a++) {
        if (arr[a].length < arr[arr.length - 1].length) {
          let lens = (arr[arr.length - 1].length) - (arr[a].length);
          let arrVal = arr[a][arr[a].length - 1];
          arr[a] = arr[a].concat(([...new Array(lens).keys()]).map(() => { return arrVal }));
        }
      }
    }
  }
  return arr;
}
function retInfo (list, col, leftArr) {
  if (col.length === 0) return 0;
  for (let i = 0; i < leftArr[0].length; i++) {
    let leftArrStr = '';
    let listStr = '';
    col.forEach((val, index) => {
      listStr += list[col[index]];
      leftArrStr += leftArr[index][i];
    });
    if (leftArrStr === listStr) {
      return i;
    }
  }
}
function upFor (col, sum, obj, row) {
  if (col.length > 0) {
    let objs = {
      label: col[0],
      children: [],
      config: row[0]
    };
    let cols = JSON.parse(JSON.stringify(col))
    cols.splice(0, 1);
    objs.children = upFor(cols, sum, [], row.splice(0,1));
    obj.push(objs);
    return obj;
  } else if (sum.length > 0) {
    obj = sum.map((val, i) => {
      let objs = {
        label: val,
        ind: filterSymbol(val)
      }
      if (row[i]) objs.config = row[i]
      return objs;
    })
    return obj;
  }
}

/**
 * 后台分页的汇总
 * info 后台接口返回的data  column 行 row 列 sum 汇总 isSummary 是否显示汇总 page 分页字典 curpage当前页数  pages总页数
 * */
export function serverPageSummary (info, column, row, sum, isSummary, page, { contrastVal, pool, isPool, isBasis }) {
  console.log('后台汇总', info, column, row, sum, isSummary, page)
  if (JSON.stringify(info.cols) === '{}') return {
    top: [],
    list: []
  };
  let clo = column.map(val => {
    if (val.sort && val.sort.value) {
      return val.sort.value;
    } else {
      return [];
    }
  });

  // 计算列数
  let topCount = 0;


  // 做一个头部字典结构
  let arrObj = {};
  let topObj = {};
  for (let i in info.cols) {
    const colsArr = i.split(/\1{1}/g);
    for (let ss = 0; ss < colsArr.length; ss++) {
      if (column[ss] && colsArr[ss] && column[ss].type === 'date' && column[ss].format && column[ss].format === 'yyyy-MM-dd EEE') {
        colsArr[ss] = colsArr[ss] + ' 星期' + getWeek(colsArr[ss])
      } else if (column[ss] && colsArr[ss] && column[ss].type === 'date' && column[ss].format && column[ss].format === 'EEE') {
        colsArr[ss] = '星期' + getWeek(colsArr[ss])
      }
    }
    structureObj(colsArr, arrObj, i);
  }

  // 检测排序
  if (JSON.stringify(arrObj) !== '{}') {
    const objCount = objFile(clo, arrObj, sum.map(vals => { return vals.name }), topCount, column, sum);
    topObj = objCount.info;
    topCount = objCount.count;
  }

  // 由配置信息带出的头部
  let leftObj = configTopFun(column, row, {});
  if (typeof leftObj === 'object' && Array.isArray(leftObj)) {
    for (let i = 0; i < leftObj.length; i++) {
      topObj.unshift(leftObj[leftObj.length - i - 1]);
    }
  } else {
    topObj.unshift(leftObj);
  }

  // 横向汇总
  if (isSummary && isSummary === 1) {
    // if (isSummary && isSummary === 1 && column.length > 0) {
    sum.forEach(vals => {
      let str = vals.name;
      (info.list).forEach((list, index) => {
        // 汇总两位小数兼容
        let sumNums = 0;
        for (let i in list) {
          if (i.substring(i.length - str.length) === str) {
            const sumVal = Number(list[i]) * 100
            sumNums = sumVal + sumNums;
            // sumNums += Number(list[i]);
          }
        }
        info.list[index][str + '汇总'] = sumNums / 100;
        // info.list[index][str + '汇总'] = sumNums;
      })
    });

    if (column.length > 0) {
      // 表头添加汇总
      let sumTop = {
        label: '汇总',
        children: sum.map(val => {
          return {
            label: val.name,
            ind: filterStr(val.name + '汇总')
          }
        })
      };
      topObj.push(sumTop);
    }

    // 最后一行的汇总数据添加
    if (page.curpage === page.pages) {
      if (row && row.length > 0) {
        let lists = JSON.parse(JSON.stringify(info.cols));
        row.forEach(val => {
          let str = filterStr(val.name);
          lists[str] = '汇总';
        })
        let listAll = JSON.parse(JSON.stringify(info.list));
        if (sum) {
          sum.map(val => {
            let sumCount = 0
            const name = val.name
            for (const items in lists) {
              // 需要走一次拆分
              const str = items.split(/\1{1}/g)
              if (str[str.length - 1] === name) {
                const sumVal = lists[items] * 100
                sumCount += sumVal
                // sumCount += lists[items]
              }
            }
            lists[filterStr(name + '汇总')] = sumCount / 100
            // lists[filterStr(name + '汇总')] = sumCount
          })
        }
        listAll.push(lists);
        info.list = listAll;
      }
    }
  }

  // 给全部数据做一次特殊字符去除
  if (info.list && info.list.length > 0) {
    for (let i = 0; i < info.list.length; i++) {
      let lists = JSON.parse(JSON.stringify(info.list[i]));
      for (let a in lists) {
        let as = filterStr(a);
        if (as !== a) {
          lists[as] = JSON.parse(JSON.stringify(lists[a]));
          delete lists[a];
        }
      }
      info.list[i] = lists;
    }
  }


  // 判断列汇总（使用列字段计算）
  if (column && column.length > 0) {
    for (let i = 0; i < column.length; i++) {
      if (column[i].pool && column[i].poolConfig && column[i].poolConfig.length > 0) {
        // 与汇总字段进行遍历同步汇总最新的name
        const poolSum = column[i].poolConfig.map(it => {
          const ind = sum.findIndex(its => its.title === it.title && its.type === it.type)
          if (ind !== -1) {
            it.name === sum[ind].name
          }
          return it
        })
        try {
          console.log('计算2')
          topObj = poolColumn(topObj, poolSum, i, 0, info.list, column[0].name, sum)
        } catch (err) {
          console.log(err)
        }
      }
    }
  }

  if (row && row.length > 0) {
    const cols = row.map(val => { return val.name })
    console.log('列计算', row, cols)

    // 与汇总字段进行遍历同步汇总最新的name
    const endObj = {}
    for (const a of sum) {
      console.log('最终个数', poolEnd(topObj, a.name, []))
      const lenS = poolEnd(topObj, a.name, [])
      endObj[a.name] = lenS
    }

    for (let i = 0; i < row.length; i++) {
      if (row[i].pool && row[i].poolConfig && row[i].poolConfig.length > 0) {
        const poolSum = row[i].poolConfig.map(it => {
          const ind = sum.findIndex(its => its.title === it.title && its.type === it.type)
          if (ind !== -1) {
            it.name === sum[ind].name
          }
          return it
        })
        try {
          info.list = rowPool1(cols.slice(0, i + 1), poolSum, info.list, endObj, cols[i + 1])
        } catch (err) { console.log(err) }
        console.log('行输出', info.list)
      }
    }
  }

  if (isPool && pool && pool.length > 0 && column && column.length > 0 && (contrastVal.length > 0 || (!contrastVal || contrastVal.length === 0) && !isBasis)) {
    topObj = contrastSort(topObj, info.list, { target: column.length, current: 0, contrastVal: contrastVal, pool: pool })
  }

  let partitionList = null
  if (row && row[0] && row[0].partition) {
    if (!column || column.length === 0) {
      topObj = topObj.slice(1, topObj.length)
    } else {
      const topArrseOne = partitionArr(JSON.parse(JSON.stringify([topObj[0]])), row[0].name)
      topObj[0] = topArrseOne[0]
    }
    const rowKey = row[0].name
    partitionList = Array.from(new Set(info.list.map(it => it[rowKey])))
    if (isSummary && info.list[info.list.length - 1][row[0].name] === '汇总') {
      partitionList.splice(partitionList.length - 1, 1)
    }
    info.list = info.list.map((it, index) => {
      it.rowIndexNew = index
      return it
    })
  }
  console.log('计算后的', topObj, info.list)
  const hp = {
    topCount: topCount,
    top: topObj,
    list: info.list
  }
  if (partitionList) hp.partitionList = partitionList
  return hp
}
// function rowPool1 (key = [], config, dateArr = [], endObj, nKey) {
//   console.log('下来走', key, config, dateArr, endObj)
//   if (!key || key.length === 0 || dateArr.length === 0) return dateArr
//   const rtArr = []
//   let hKey = []
//   for (let i = 0; i < dateArr.length; i++) {
//     const one = key.map(it => dateArr[i][it]).join('')
//     const two = dateArr[i + 1] ? key.map(it => dateArr[i + 1][it]).join('') : ''
//     rtArr.push(dateArr[i])
//     // console.log('判断数据是否一样', two, one)
//     if (two === one) {
//       // 前后两条一样的，挂起当条的数据做合并
//       hKey.push(dateArr[i])
//     } else {
//       if (hKey.length > 0) {
//         // 这边走配置汇总的内容决定他是什么汇总方式
//         hKey.push(dateArr[i])
//         const ob = { isPool: true }
//         for (const ss of key) {
//           ob[ss] = dateArr[i][ss]
//         }
//         for (const ss of config) {
//           // 获取到固定字段的下列
//           if (endObj[ss.name]) {
//             if (endObj[ss.name] && endObj[ss.name].length > 0) {
//               for (let sa = 0; sa < endObj[ss.name].length; sa++) {
//                 const aa = endObj[ss.name][sa]
//                 // console.log('合计数组4', aa)
//                 if (ss.condition !== 'formula') {
//                   const aaArr = hKey.map(it => it[aa] || it[aa] === 0 ? it[aa] : '')
//                   ob[aa] = countPool(aaArr, ss.condition)  
//                 } else {
//                   ob[aa] = rowPoolFormula(hKey, ss.formula.condition, endObj, sa)
//                 }
//               }
//             }
//           }
//           ob[key[key.length - 1]] = ss.label
//         }
//         rtArr.push(ob)
//         hKey = []
//       }
//     }
//   }
//   return rtArr
// }

// 行合计
function rowPoolFormula (hKey = [], formula, endObj, key) {
  // console.log('行合计', hKey, formula, endObj)
  if (!formula) return ''
  const strFilter = formula.match(/([A-Z]+)\((.*)\)/);
  if (strFilter && strFilter.length >= 3) {
    const mathFun = strFilter[1];
    const nameVal = strFilter[2];
    const s = nameVal.replace(/<[^>]+>/g, function(match) { 
      const v = match.replace(/<|>/g, '')
      if (endObj[v]) {
        const n = endObj[v][key]
        const t = hKey.map(it => it[n] || it[n] === 0 ? it[n] : '')
        return t && t.length > 0 ? math.sum(t) : ''
      }
    })
    return mathFunRun(s, mathFun)
  }
}
// 头部数组结构获取
function structureObj (arr, obj, val) {
  let arrs = JSON.parse(JSON.stringify(arr));
  arrs.splice(0, 1);
  // 因为字典索引为数字时，会发生排序所以统一加一个 - (后面转数组在去掉)
  let str = arr[0] + '-';
  if (!obj[str]) obj[str] = {};
  if (arrs.length > 0) {
    obj[str] = structureObj(arrs, obj[str], val);
  } else {
    obj[str] = val;
  }
  return obj;
}
// 排序
function objFile (arr, obj, sum, countTop, column, summary) {
  // console.log('123', JSON.parse(JSON.stringify(arr)), JSON.parse(JSON.stringify(obj)), '------------------------------')

  let info = [];
  // 如果没有就直接进行数组赋值
  if (arr.length === 0 && JSON.stringify(obj) !== '{}') {
    for (let i in obj) {
      let str = i.slice(0, i.length - 1);
      if (typeof obj[i] === 'string') {
        countTop += 1;
        // 如果是字符串则代表当前是汇总的（只有再汇总大于1时才执行）
        const oob = { label: str, ind: filterStr(obj[i]) }
        const oobInd = summary.findIndex(it => it.name === str)
        if (oobInd !== -1) {
          oob.order = summary[oobInd].order || false
          oob.screen = summary[oobInd].screen || false
        }
        if (sum.length > 1) {
          // 找到对应位置
          let sumIndex = sum.indexOf(str);
          info[sumIndex] = oob;
          // info[sumIndex] = { label: str, ind: filterStr(obj[i]) };
        } else {
          info.push(oob);
          // info.push({ label: str, ind: filterStr(obj[i]) });
        }
      } else if (typeof obj[i] === 'object') {
        const columns = JSON.parse(JSON.stringify(column))
        const objCount = objFile([], obj[i], sum, countTop, columns.slice(1, columns.length), summary);
        countTop = objCount.count;
        // 检测当前是否需要排序
        if (columns && columns.length > 0 && columns[0].sort) {
          const sort = columns[0].sort.value
          // 升序 or 降序
          if (sort === 'desc' || sort === 'asc') {
            objCount.info = objCount.info.sort(compare('label', sort))
          }
        }
        info.push({ label: str, children: objCount.info });
      }
    }
  } else {
    let arrs = JSON.parse(JSON.stringify(arr));
    if (arrs.length > 0) arrs.splice(0, 1);
    // 遍历配置比对字典，存在就拿出来数据进行筛选操作并删掉对应（做完遍历之后再对剩下的进行操作）
    if (arr[0] && typeof arr[0] === 'object' && arr[0].length > 0) {
      (arr[0]).forEach(vals => {
        if (obj[vals + '-']) {
          if (typeof obj[vals + '-'] === 'object') {
            const columns = JSON.parse(JSON.stringify(column))
            const objCount = objFile(arrs, JSON.parse(JSON.stringify(obj[vals + '-'])), sum, countTop, columns.slice(1, columns.length), summary);
            countTop = objCount.count;
            // 检测当前是否需要排序
            if (columns && columns.length > 0 && columns[0].sort) {
              const sort = columns[0].sort.value
              // 升序 or 降序
              if (sort === 'desc' || sort === 'asc') {
                objCount.info = objCount.info.sort(compare('label', sort))
              }
            }
            info.push({
              label: vals,
              children: objCount.info
            });
            // 用完删掉
            delete obj[vals + '-'];
          }
        }
      })
    }

    // 配置之外的
    if (JSON.stringify(obj) !== '{}') {
      const columns = JSON.parse(JSON.stringify(column))
      const objCount = objFile([], obj, sum, countTop, columns.slice(1, columns.length), summary);
      countTop = objCount.count;
      // 检测当前是否需要排序
      if (columns && columns.length > 0 && columns[0].sort) {
        const sort = columns[0].sort.value
        // 升序 or 降序
        if (sort === 'desc' || sort === 'asc') {
          objCount.info = objCount.info.sort(compare('label', sort))
        }
      }
      info = info.concat(objCount.info);
    }
  }
  return { info: info, count: countTop };
}
// sort 排序
const compare = function (prop, s) {
  return function (obj1, obj2) {
    let val1 = obj1[prop];
    let val2 = obj2[prop];
    if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
      val1 = Number(val1);
      val2 = Number(val2);
    }
    if (s === 'asc') {
      if (val1 < val2) {
        return -1;
      } else if (val1 > val2) {
        return 1;
      } else {
        return 0;
      }
    } else {
      if (val1 > val2) {
        return -1;
      } else if (val1 < val2) {
        return 1;
      } else {
        return 0;
      }
    }
  }
}

// 配置信息带出头部
function configTopFun (colArr, rowArr, obj) {
  let objs = JSON.parse(JSON.stringify(obj));
  if (colArr.length === 0) {
    if (rowArr.length > 0) {
      let ars = rowArr.map(val => {
        const obs = {
          label: val.name,
          ind: filterStr(val.name)
        }
        if (val.isFormatNum) obs.config = val
        return obs
      });
      return ars;
    }
  } else {
    let colArrs = JSON.parse(JSON.stringify(colArr));
    colArrs.splice(0, 1);
    objs.label = colArr[0].name;
    if (rowArr.length > 0) {
      let childrens = configTopFun(colArrs, rowArr, {});
      if (!Array.isArray(childrens) && typeof childrens === 'object') {
        objs.children = [childrens];
      } else {
        objs.children = childrens;
      }
    } else {
      if (colArrs.length > 0) {
        objs.children = [configTopFun(colArrs, rowArr, {})];
      }
    }
  }
  return objs;
}
// 过滤特殊字符
export function filterStr (str) {
  str = (str.split(/\1{1}/g)).join('');
  let pattern = new RegExp("[`~!@#$^&*()={}'-():;',\\[\\].<>?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]");
  let specialStr = "";
  for (let i = 0; i < str.length; i++) {
    specialStr += str.substr(i, 1).replace(pattern, '');
  }
  return specialStr;
}

/**
 * 拆公式字段
 * */
export function xFormula (val) {
  let strIndex = val.indexOf('(');
  let str = val.slice((strIndex + 1), val.length - 1);
  let formula = val.slice(0, strIndex);
  return {
    name: str,
    // name: '$' + str,
    formula: formula
  }
}

// 标签颜色判断
export function getLabelColor (item, value, isC, colorType = '1') {
  for (const i of (item.options || [])) {
    if (i.value || i.value === 0 || i.value === '') {
      switch (i.condition) {
        // 等于
        case 'eq':
          if (Number.isNaN(Number(i.value)) || Number.isNaN(Number(value))|| Number.isNaN(Number(value)) === 0) {
            if (i.value === value) return getColor(i)
          } else {
            if (Number(i.value) === Number(value)) return getColor(i)
          }
          break
        // 大于
        case 'gt':
          if (Number.isNaN(Number(i.value)) || Number.isNaN(Number(value))) {
            if (i.value < value) return getColor(i)
          } else {
            if (Number(i.value) < Number(value)) return getColor(i)
          }
          break
        // 大于等于
        case 'gte':
          if (Number.isNaN(Number(i.value)) || Number.isNaN(Number(value))) {
            if (i.value <= value) return getColor(i)
          } else {
            if (Number(i.value) <= Number(value)) return getColor(i)
          }
          break
        // 小于
        case 'lt':
          if (Number.isNaN(Number(i.value)) || Number.isNaN(Number(value))) {
            if (i.value > value) return getColor(i)
          } else {
            if (Number(i.value) > Number(value)) return getColor(i)
          }
          break
        // 小于等于
        case 'lte':
          if (Number.isNaN(Number(i.value)) || Number.isNaN(Number(value))) {
            if (i.value >= value) return getColor(i)
          } else {
            if (Number(i.value) >= Number(value)) return getColor(i)
          }
          break
      }
    }
  }
  return {}
  function getColor(its) {
    if (colorType === '2' || colorType === '3') {
      return {
        color: its.color,
      }
    } else {
      return {
        display: 'inline-block',
        borderRadius: '16px',
        padding: '2px 16px',
        color: `${its.color} !important`,
        backgroundColor: its.color + (!isC ? '1a' : '')
      }
    }
  }
}

// 查询开放能力列表（仪表盘配置使用）
import { getcompetencymanagelist } from '@/port/admins/instrument'
export const getAbilityList = async () => {
  const { code, data } = await getcompetencymanagelist({curpage: 0, pagesize: 0, type: 1}).catch(err => { console.log(err) })
  if (code === 0) {
    return data
  }
}

// 能力跳转 url 生成
export const nextProcess = async (info, self) => {
  let url = ''
  const par = {
    type: 1,
    curpage: 0,
    pagesize: 0,
    id: info
  }
  const { data, code, msg } = await getcompetencymanagelist(par).catch(err => { console.log(err) })
  if (code === 0) {
    // console.log(self.$url);
    const item = data[0]
    // console.log(item.name,'asda');
    if (item.type === 1) {
      switch (item.name) {
        case '任务协同工具':
          url = '/mission/myFillIn'
          break
        case '组织协同工具':
          url = `${self.$url}/tripartiteLogin?isZt=${self.$zturl}&redirect=/diagrams/memberManagements`
          break
        case '区块链存储':
          // 等黄婉确定
          url = `${self.$url}/tripartiteLogin?isZt=${self.$zturl}&redirect=/blockchain`
          break
        case '统一认证能力':
          // 等黄婉确定
          url = `${self.$url}/tripartiteLogin?isZt=${self.$zturl}&redirect=/UA`
          break
        case '组织架构赋能':
          // 等黄婉确定
          url = `${self.$url}/tripartiteLogin?isZt=${self.$zturl}&redirect=/OSE`
          break
        case '人工智能查询':
          // 等黄婉确定
          url = '/aichatNew'
          // url = `${this.$url}/tripartiteLogin?isZt=${this.$zturl}`
          break
        case '即时通讯工具':
          url = 'https://kdocs.cn/l/csDFZ8Vgs7Dk'
          break
        case '网盘工具':
          url = 'https://kdocs.cn/l/cu8aGKjXMUJF'
          break
        case '人脸识别':
          url = 'https://kdocs.cn/l/cdTIH5RBHbPE'
          break
        case '电子签章':
          url = 'https://kdocs.cn/l/clfW78eHgvlr'
          break
        default:
          // 等黄婉确认
          break
      }
    }
    return {
      url,
      item
    }
  } else {
    self.$message.error(msg)
  }
}

// 仪表盘筛选组件时间值转化
// import { formatDate } from './global'
// export const getTimeInstrument = (key, isTime = true) => {
//   // console.log('时间转化', key)
//   // formatDate(new Date(), 'yyyy-MM-dd')
//   const date = new Date()
//   const one = 1000 * 60 * 60 * 24
//   switch (key) {
//     case 'thatDay':
//       const t = formatDate(date, 'yyyy-MM-dd')
//       // console.log('时间转化', key, t)

//       return isTime ? [ t + ' 00:00:00', t + ' 23:59:59' ] : [ t, t ]
//     case 'yesterday':
//       let s = date.getTime()
//       s = s - one
//       const t1 = formatDate(new Date(s), 'yyyy-MM-dd')
//       return isTime ? [ t1 + ' 00:00:00', t1 + ' 23:59:59' ] : [ t1, t1 ]
//     case 'thisWeek':
//       let s1 = date.getTime()
//       const z = date.getDay()
//       s1 = s1 - ((z === 0 ? 6 : z - 1) * one)
//       let s11 = date.getTime()
//       if (z !== 0) s11 = s11 + (one * (6 - z))
//       const t2 = formatDate(new Date(s1), 'yyyy-MM-dd')
//       const t22 = formatDate(new Date(s11), 'yyyy-MM-dd')
//       return isTime ? [ t2 + ' 00:00:00', t22 + ' 23:59:59' ] : [ t2, t22 ]
//     case 'lastWeek':
//       let s2 = date.getTime() - (7 * one)
//       const z1 = date.getDay()
//       s2 = s2 - ((z1 === 0 ? 6 : z1 - 1) * one)
//       let s22 = date.getTime() - (7 * one)
//       if (z1 !== 0) s22 = s22 + (one * (6 - z1))
//       const t3 = formatDate(new Date(s2), 'yyyy-MM-dd')
//       const t33 = formatDate(new Date(s22), 'yyyy-MM-dd')
//       return isTime ? [ t3 + ' 00:00:00', t33 + ' 23:59:59' ] : [ t3, t33 ]
//     case 'thisMonth':
//       const tt3 = formatDate(new Date(), 'yyyy-MM') + '-01'
//       const t4 = new Date(tt3)
//       const tmm = new Date(tt3).getMonth() + 1
//       const tm = new Date(t4.getFullYear(), tmm, 1).getTime() - 1
//       return isTime ? [ tt3 + ' 00:00:00', formatDate(new Date(tm), 'yyyy-MM-dd') + ' 23:59:59' ] : [ tt3, formatDate(new Date(tm), 'yyyy-MM-dd') ]
//     case 'lastMonth':
//       const l3 = new Date(formatDate(new Date(), 'yyyy-MM') + '-01 00:00:00').getTime() - 1
//       const l4 = formatDate(new Date(l3), 'yyyy-MM') + '-01'
//       return isTime ? [ l4 + ' 00:00:00', formatDate(new Date(l3), 'yyyy-MM-dd') + ' 23:59:59' ] : [ l4 , formatDate(new Date(l3), 'yyyy-MM-dd') ]
//   }
//   return ''
// }


export const getShowFiled = (config, summary) => {
  let summaryList = JSON.parse(JSON.stringify(summary))
  let showFiled = null
  for (const ele of config) {
    if (ele.type === 'button' && ele.info.bindingFunction === 'show-filed') {
      showFiled = ele.info.showFiledInfo.list
      break
    }
  }
  if (!showFiled) return summaryList
  summaryList = summaryList.filter(f => showFiled.includes(f.title))
  return summaryList
}

export const getHidenList = (list, summary) => {
  const sum = summary.map(m => m.name)
  const li = cloneDeep(list)
  for (const ele of list) {
    if (ele.children) {
      const itme = li.find(f=>f.label === ele.label)
      itme.children = getHidenList(ele.children, summary)
    } else {
      const item = list.find(f=>f.label === ele.label)
      const label1 = (item.ind || '').substring(0, 2)
      const flag = sum.includes(item.label)
      const cFlag = label1 === 'c_'
      const sFlag = label1 === 's_'
      if (!flag && (!item.colorConfig && !cFlag && !sFlag)) {
        const idx = li.findIndex(f => f.label === item.label)
        li.splice(idx, 1)
      }
    }
  }
  return li
}

// 仪表盘筛选组件时间值转化
import { formatDate } from './global'
export const getTimeInstrument = (key, isTime = true) => {
  // console.log('时间转化', key)
  // formatDate(new Date(), 'yyyy-MM-dd')
  const date = new Date()
  const one = 1000 * 60 * 60 * 24
  switch (key) {
    case 'thatDay':
    {
      const t = formatDate(date, 'yyyy-MM-dd')
      // console.log('时间转化', key, t)

      return isTime ? [ t + ' 00:00:00', t + ' 23:59:59' ] : [ t, t ]
    }
    case 'yesterday':
    {
      let s = date.getTime()
      s = s - one
      const t1 = formatDate(new Date(s), 'yyyy-MM-dd')
      return isTime ? [ t1 + ' 00:00:00', t1 + ' 23:59:59' ] : [ t1, t1 ]
    }
    case 'thisWeek':
    {
      let s1 = date.getTime()
      const z = date.getDay()
      s1 = s1 - ((z === 0 ? 6 : z - 1) * one)
      let s11 = date.getTime()
      if (z !== 0) s11 = s11 + (one * (6 - z))
      const t2 = formatDate(new Date(s1), 'yyyy-MM-dd')
      const t22 = formatDate(new Date(s11), 'yyyy-MM-dd')
      return isTime ? [ t2 + ' 00:00:00', t22 + ' 23:59:59' ] : [ t2, t22 ]
    }
    case 'lastWeek':
      {
        let s2 = date.getTime() - (7 * one)
        const z1 = date.getDay()
        s2 = s2 - ((z1 === 0 ? 6 : z1 - 1) * one)
        let s22 = date.getTime() - (7 * one)
        if (z1 !== 0) s22 = s22 + (one * (6 - z1))
        const t3 = formatDate(new Date(s2), 'yyyy-MM-dd')
        const t33 = formatDate(new Date(s22), 'yyyy-MM-dd')
        return isTime ? [ t3 + ' 00:00:00', t33 + ' 23:59:59' ] : [ t3, t33 ]
      }
    case 'thisMonth':
      {
        const tt3 = formatDate(new Date(), 'yyyy-MM') + '-01'
        const t4 = new Date(tt3)
        const tmm = new Date(tt3).getMonth() + 1
        const tm = new Date(t4.getFullYear(), tmm, 1).getTime() - 1
        return isTime ? [ tt3 + ' 00:00:00', formatDate(new Date(tm), 'yyyy-MM-dd') + ' 23:59:59' ] : [ tt3, formatDate(new Date(tm), 'yyyy-MM-dd') ]
      }
    case 'lastMonth':
      {
        const l3 = new Date(formatDate(new Date(), 'yyyy-MM') + '-01 00:00:00').getTime() - 1
        const l4 = formatDate(new Date(l3), 'yyyy-MM') + '-01'
        return isTime ? [ l4 + ' 00:00:00', formatDate(new Date(l3), 'yyyy-MM-dd') + ' 23:59:59' ] : [ l4 , formatDate(new Date(l3), 'yyyy-MM-dd') ]
      }
  }
  return ''
}